// Атрибуты доступности для страниц нового ядра: роли, подписи и альтернативный текст там, где
// шаблоны, подмены из БД, блоки доставок и сторонние виджеты их не задали. Меняются только
// атрибуты, которые не влияют на вид: role, aria-*, alt, title, tabindex у пустых ссылок.

const SERVICE_NAMES = [
    [/(^|\.)apps\.apple\.com$|(^|\.)itunes\.apple\.com$/, 'App Store'],
    [/(^|\.)play\.google\.com$/, 'Google Play'],
    [/(^|\.)appgallery\.huawei\.com$/, 'AppGallery'],
    [/(^|\.)apps\.rustore\.ru$|(^|\.)rustore\.ru$/, 'RuStore'],
    [/(^|\.)vk\.com$|(^|\.)vk\.ru$/, 'ВКонтакте'],
    [/(^|\.)ok\.ru$/, 'Одноклассники'],
    [/(^|\.)t\.me$|(^|\.)telegram\.me$/, 'Telegram'],
    [/(^|\.)wa\.me$|(^|\.)whatsapp\.com$/, 'WhatsApp'],
    [/(^|\.)max\.ru$/, 'MAX'],
    [/(^|\.)instagram\.com$/, 'Instagram'],
    [/(^|\.)youtube\.com$|(^|\.)youtu\.be$/, 'YouTube'],
    [/(^|\.)rutube\.ru$/, 'Rutube'],
    [/(^|\.)dzen\.ru$/, 'Дзен'],
    [/(^|\.)facebook\.com$/, 'Facebook'],
    [/(^|\.)twitter\.com$|(^|\.)x\.com$/, 'X'],
    [/(^|\.)2gis\.ru$/, '2ГИС'],
    [/(^|\.)yandex\.ru$|(^|\.)ya\.ru$/, 'Яндекс'],
];

// Подписи элементов управления без текста по их классу.
const CONTROL_NAMES = [
    ['navigation__toggle', 'Меню'],
    ['modal-close', 'Закрыть'],
    ['lb-close', 'Закрыть'],
    ['lb-cancel', 'Отменить загрузку'],
    ['lb-prev', 'Предыдущее фото'],
    ['lb-next', 'Следующее фото'],
    ['close', 'Закрыть'],
];

function hasAccessibleName(element) {
    if ((element.getAttribute('aria-label') || '').trim() || element.getAttribute('aria-labelledby') || (element.getAttribute('title') || '').trim()) {
        return true;
    }
    if ((element.textContent || '').trim()) {
        return true;
    }
    if (!element.firstElementChild) {
        return false;
    }
    const images = element.querySelectorAll('img[alt], [aria-label]');
    for (let i = 0; i < images.length; i++) {
        if ((images[i].getAttribute('alt') || images[i].getAttribute('aria-label') || '').trim()) {
            return true;
        }
    }
    return false;
}

function controlName(element) {
    for (let i = 0; i < CONTROL_NAMES.length; i++) {
        if (element.classList.contains(CONTROL_NAMES[i][0])) {
            return CONTROL_NAMES[i][1];
        }
    }
    return null;
}

function nameButton(button) {
    if (hasAccessibleName(button)) {
        return;
    }
    const name = controlName(button);
    if (name) {
        button.setAttribute('aria-label', name);
    }
}

function linkName(link, win) {
    const href = (link.getAttribute('href') || '').trim();
    const control = controlName(link);
    if (control) {
        return control;
    }
    // Пустой адрес, якорь и javascript: ведут на эту же страницу: имени по адресу у них нет.
    if (href === '' || href.charAt(0) === '#' || /^javascript:/i.test(href)) {
        return null;
    }
    if (/^mailto:/i.test(href)) {
        const address = decodeURIComponent(href.slice(7).split('?')[0]);
        return address ? `Написать на ${address}` : null;
    }
    if (/^tel:/i.test(href)) {
        return `Позвонить ${href.slice(4)}`;
    }
    let host = '';
    try {
        host = new win.URL(href, win.location.href).hostname.replace(/^www\./, '');
    } catch (error) {
        return null;
    }
    for (let i = 0; i < SERVICE_NAMES.length; i++) {
        if (SERVICE_NAMES[i][0].test(host)) {
            return SERVICE_NAMES[i][1];
        }
    }
    return host || null;
}

// Подпись поля формы: подсказка в поле, выбор в карточке товара или подпись строки формы (.form-row-caption).
function fieldName(field) {
    const placeholder = (field.getAttribute('placeholder') || '').trim();
    if (placeholder) {
        return placeholder;
    }
    // В карточке товара выбирают вариант (active_mod) или число порций (multiplier) этого товара.
    const card = field.tagName === 'SELECT' && field.closest('.thumbnail');
    const title = card && card.querySelector('.thumbnail__caption');
    if (title) {
        const kind = /multiplier/.test(field.getAttribute('ng-model') || '') ? 'Количество' : 'Вариант';
        const product = title.textContent.replace(/\s+/g, ' ').trim();
        return product ? `${kind}: ${product}` : kind;
    }
    // .form-row-content тоже бывает .c-row: сначала ищем строку формы целиком.
    const row = field.closest('.form-row') || field.closest('.c-row');
    const caption = row && row.querySelector('.form-row-caption');
    const text = caption ? caption.textContent.replace(/\s+/g, ' ').trim().replace(/[:*\s]+$/, '') : '';
    return text || null;
}

function hasFieldLabel(field) {
    return Boolean((field.labels && field.labels.length) || field.getAttribute('aria-labelledby') || (field.getAttribute('title') || '').trim());
}

function frameTitle(frame) {
    const src = frame.getAttribute('src') || '';
    if (/yandex\.[a-z]+\/map-widget|api-maps\.yandex/.test(src)) {
        return 'Карта';
    }
    if (/google\.com\/recaptcha/.test(src)) {
        return 'reCAPTCHA';
    }
    if (/youtube\.com|rutube\.ru|vk\.com\/video/.test(src)) {
        return 'Видео';
    }
    return 'Встроенное содержимое';
}

function each(root, selector, fn) {
    if (root.nodeType === 1 && root.matches(selector)) {
        fn(root);
    }
    // Текст и комментарии не могут совпасть с селектором элементов.
    if (!root.firstElementChild) {
        return;
    }
    const found = root.querySelectorAll(selector);
    for (let i = 0; i < found.length; i++) {
        fn(found[i]);
    }
}

function improve(root, win) {
    // Ссылка без href с обработчиком нажатия работает как кнопка; именованные якоря не трогаем.
    each(root, 'a:not([href]):not([role]):not([id]):not([name])', link => {
        link.setAttribute('role', 'button');
        if (!link.hasAttribute('aria-label')) {
            nameButton(link);
        }
    });
    each(root, 'a[href]:not([aria-label])', link => {
        if (hasAccessibleName(link)) {
            return;
        }
        const name = linkName(link, win);
        if (name) {
            link.setAttribute('aria-label', name);
        } else if (/^mailto:$/i.test((link.getAttribute('href') || '').trim())) {
            // Пустая ссылка mailto: без адреса: на экране её нет, из навигации с клавиатуры убираем.
            link.setAttribute('aria-hidden', 'true');
            link.setAttribute('tabindex', '-1');
        }
    });
    each(root, 'button:not([aria-label])', nameButton);
    each(root, 'input:not([type="hidden"]):not([aria-label]), select:not([aria-label]), textarea:not([aria-label])', field => {
        if (!hasFieldLabel(field)) {
            const name = fieldName(field);
            if (name) {
                field.setAttribute('aria-label', name);
            }
        }
    });
    each(root, 'img:not([alt])', image => image.setAttribute('alt', ''));
    each(root, 'iframe:not([title])', frame => frame.setAttribute('title', frameTitle(frame)));
}

// Страница целиком после запуска и элементы, которые позже добавят ядро, библиотеки и виджеты.
export function installAccessibility(doc) {
    const win = doc.defaultView;
    improve(doc.documentElement, win);
    if (!win.MutationObserver) {
        return;
    }
    const observer = new win.MutationObserver(records => {
        for (let i = 0; i < records.length; i++) {
            const added = records[i].addedNodes;
            for (let j = 0; j < added.length; j++) {
                if (added[j].nodeType === 1) {
                    improve(added[j], win);
                }
            }
        }
    });
    observer.observe(doc.documentElement, { childList: true, subtree: true });
}
